module.exports = __webpack_public_path__ + "static/img/no_data.f6cd303.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/no_data.png
// module id = /AAl
// module chunks = 1